<template>
    <main-content>
        <shareholder-form :records="records">
        </shareholder-form>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content';
    import shareholderForm from './components/shareholder-form'

    export default {
        components: {
            mainContent,
            shareholderForm,
        },
        data() {
            return {
                records: [
                    {
                        iban: '',
                        full_name: '',
                        hashid: '',
                    },
                ],
            };
        },
    }
</script>
